import React from "react";

const PlanInvestissement = () => {
  return (
    <div className="plan-investissement">
      <h2>Plan d’investissement</h2>
      <p>Planification et projection des futurs investissements.</p>
    </div>
  );
};

export default PlanInvestissement;
